import { getAppSettings } from "@/services/misc/appSettings.client";
import { useQuery } from "@tanstack/react-query";

export function useAppSettings() {
  return useQuery({
    queryKey: ["app-settings"],
    queryFn: async () => {
      const res = await getAppSettings();
      if (!res.status) {
        throw new Error(res.message);
      }
      return res.data.data;
    },
    staleTime: Infinity,
  });
}
